import { QUERY_PRESETS } from "@/queries/queryTimeConfig";

export const boardPlanConfig = {
  /* ------------------------------- POST ---------------------------------- */

  createBoardPlan: {
    key: "createBoardPlan",
    url: "/api/v1/board-plans",
    method: "POST",
    options: {
      retry: 2,
      invalidateKeys: ["getBoardPlans"],
      onSuccessMessage: "Rate plan created successfully",
      onErrorMessage: "Failed to create rate plan",
    },
  },

  getBoardPlans: {
    key: "getBoardPlans",
    url: "/api/v1/board-plans",
    method: "GET",
    options: {
      ...QUERY_PRESETS.LIST,
    },
  },

  getBoardPlanById: {
    key: "getBoardPlanById",
    url: (data) => `/api/v1/board-plans/${data.id}`,
    method: "GET",
    options: {
      ...QUERY_PRESETS.DETAIL,
    },
  },

  /* ------------------------------- PATCH --------------------------------- */

  updateBoardPlan: {
    key: "updateBoardPlan",
    url: (data) => `/api/v1/board-plans/${data.id}`,
    method: "PATCH",
    options: {
      retry: 2,
      invalidateKeys: ["getBoardPlans", "getBoardPlanById"],
      onSuccessMessage: "Rate plan updated successfully",
      onErrorMessage: "Failed to update rate plan",
    },
  },

  /* ------------------------------- DELETE --------------------------------- */

  deleteBoardPlan: {
    key: "deleteBoardPlan",
    url: (data) => `/api/v1/board-plans/${data.id}`,
    method: "DELETE",
    options: {
      retry: 2,
      invalidateKeys: ["getBoardPlans", "getDeletedBoardPlans"],
      onSuccessMessage: "Rate plan deleted successfully",
      onErrorMessage: "Failed to delete rate plan",
    },
  },

  getDeletedBoardPlans: {
    key: "getDeletedBoardPlans",
    url: "/api/v1/board-plans/deleted",
    method: "GET",
    options: {
      retry: 2,
    },
  },

  restoreBoardPlan: {
    key: "restoreBoardPlan",
    url: (data) => `/api/v1/board-plans/${data.id}/restore`,
    method: "PATCH",
    options: {
      retry: 2,
      invalidateKeys: ["getBoardPlans", "getDeletedBoardPlans"],
      onSuccessMessage: "Board plan restored successfully",
      onErrorMessage: "Failed to restore board plan",
    },
  },
};
